"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("../utils/object");
var constants_1 = require("../constants");
var Base_1 = require("../Base");
var EventLog_1 = require("./EventLog");
var Tealium_1 = require("../Tealium");
function round(value, precision) {
    if (precision === void 0) { precision = 1; }
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
exports.default = new (/** @class */ (function (_super) {
    __extends(JwMonitor, _super);
    function JwMonitor() {
        var _this = _super.call(this) || this;
        _this.state = {
            ad: {
                breakCount: 0,
                event: null,
                paused: false,
            },
            video: {
                started: false,
                scrubbing: false,
                volume: 100,
                position: 0,
            },
            attemptPlay: false,
            completeSent: false,
            visualQuality: null,
        };
        _this.debug = true;
        _this.loadMediaSent = false;
        _this.init = function (options) {
            if (!window.utag) {
                _this.warn('utag needs to be loaded in order to use JwMonitor library');
            }
            if (options) {
                _this.options = options;
                _this.adobeDelay = options.adobeDelay;
                if (_this.options.debug) {
                    _this.events.all = _this.onAll;
                }
            }
            _this.setupInstance();
        };
        _this.setupInstance = function () {
            _this.instance = window.jwplayer();
            if (!_this.instance) {
                _this.warn("No JwPlayer instance found!");
                return;
            }
            _this.subscribeToEvents();
        };
        /**
         * Formats object and string to be valid for the subscribe of the extension
         *
         * Basic logic to subscribe to events, calls subscribe from the extension to subscribe to the event
         */
        _this.subscribeToEvents = function () {
            if (!_this.events || Object.keys(_this.events).length === 0) {
                _this.warn('subscribeToEvents: No events set!');
                return;
            }
            Object.keys(_this.events).forEach(function (eventKey) {
                var key = eventKey;
                _this.subscribe(key, _this.eventWrapper(_this.events[key]));
            });
        };
        /**
         * Fires an event to Tealium (TAQ)
         */
        _this.eventWrapper = function (callback) { return function (event) {
            var _a;
            // Collect all the necessary data for the track event
            var collectCallbackData = callback(event);
            // When we return false in a callback we will not fire the track event any more
            if (collectCallbackData === false) {
                return;
            }
            var eventType = event.type;
            // Check for custom event callbacks
            var clientCallbackData = {};
            if (((_a = _this.options) === null || _a === void 0 ? void 0 : _a.events) && typeof _this.options.events[eventType] === 'function') {
                var callbackData = _this.options.events[eventType](event);
                if (callbackData === false) {
                    // Don't sent event
                    return;
                }
                clientCallbackData = callbackData;
            }
            var trackData = _this.getTrackData();
            var event_action = collectCallbackData.event_action;
            Tealium_1.default.video(__assign(__assign(__assign(__assign({}, trackData), { event_name: "player_".concat(event_action) }), collectCallbackData), clientCallbackData));
        }; };
        _this.sendEvent = function (event) { return _this.eventWrapper(function () { return event; })({}); };
        _this.isLastEvent = function (action) { return EventLog_1.default.isLastEvent("player_".concat(action), constants_1.CallType.VIDEO); };
        _this.formatAdEvent = function (event, data) {
            return {
                event_action: data.event_action,
                event_category: 'player',
                event_label: data.event_label,
                ad: 1,
                ad_id: event.id,
                ad_position: event.adposition + '-roll',
                ad_client: event.client,
                ad_podcount: event.podcount,
                ad_sequence: event.sequence,
                ad_breakcount: _this.state.ad.breakCount,
                ad_duration: event.duration || 0,
            };
        };
        _this.getTrackData = function () {
            var _a;
            var jwData = {};
            if (_this.instance) {
                var playerConfig = void 0;
                try {
                    playerConfig = _this.instance.getConfig() || {};
                }
                catch (error) {
                    playerConfig = {};
                }
                var playlistItem = void 0;
                try {
                    playlistItem = _this.instance.getPlaylistItem();
                }
                catch (error) {
                    // ignore this error when getPlaylistItem fails
                }
                var drmType = '';
                try {
                    var source = playlistItem.sources[0];
                    drmType = source.drm ? Object.keys(source.drm)[0] : 'none';
                }
                catch (ignore) {
                    drmType = 'none';
                }
                var adState = '';
                if (_this.state.ad.event) {
                    adState = _this.state.ad.paused ? 'ad_paused' : 'ad_playing';
                }
                jwData = {
                    ad: 0,
                    c_player_position: _this.state.video.position || null,
                    media_drmtype: drmType,
                    media_encodingformat: playlistItem ? playlistItem.allSources[0].type : null,
                    media_offset: null,
                    media_playbackpercentage: playerConfig.playbackRate * 100,
                    media_playbackrate: playerConfig.playbackRate,
                    media_quality: _this.state.visualQuality ? "".concat(_this.state.visualQuality.level.height, "p") : 'auto',
                    media_thumbnail: playlistItem ? playlistItem.image : null,
                    media_type: playerConfig.audioMode ? 'audio' : 'video',
                    player_autoplay: playerConfig.autostart || null,
                    player_casting: playerConfig.castActive || false,
                    player_fullscreen: playerConfig.fullscreen || false,
                    player_height: playerConfig.containerHeight || null,
                    player_source: playlistItem ? playlistItem.file : null,
                    player_state: adState || playerConfig.state || null,
                    player_type: playerConfig.provider ? playerConfig.provider.name : null,
                    player_width: playerConfig.containerWidth || null,
                    event_category: 'player',
                };
                var qoe = _this.instance.qoe();
                var qoeFields = {
                    media_bitrate: _this.state.visualQuality ? _this.state.visualQuality.level.bitrate : 0,
                    media_startup_time: (qoe === null || qoe === void 0 ? void 0 : qoe.firstFrame) ? round(qoe.firstFrame / 1000, 3) : 0,
                    // Todo: add fps	number	FPS value
                    // Todo: add droppedFrames	number	Number of dropped frames
                };
                if (playerConfig.position) {
                    jwData.media_offset = playerConfig.position * 1000;
                }
                jwData = __assign(__assign(__assign({}, playlistItem.metadata), jwData), qoeFields);
                if (!jwData.media_name) {
                    var metadata = playlistItem.metadata, type = playlistItem.type, seriesTitle = playlistItem.seriesTitle, title = playlistItem.title, seasonNumber = playlistItem.seasonNumber, tvSeasonEpisodeNumber = playlistItem.tvSeasonEpisodeNumber;
                    jwData.media_name =
                        type === 'EPISODE' && seriesTitle
                            ? "".concat(seriesTitle, ", ").concat(seasonNumber, ", ").concat(tvSeasonEpisodeNumber)
                            : title || (metadata === null || metadata === void 0 ? void 0 : metadata.media_program_name);
                }
                // Make sure to keep correct metadata for live events
                if (playerConfig.streamType === 'LIVE') {
                    jwData.c_media_playbacktype = 'live';
                    jwData.media_duration = 0;
                }
            }
            if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.defaultLayer) {
                jwData = __assign(__assign({}, _this.options.defaultLayer), jwData);
            }
            (0, object_1.deleteNullValues)(jwData);
            return jwData;
        };
        _this.subscribe = function (on, func) {
            if (!_this.instance)
                return;
            if (on.indexOf('.') > -1) {
                var _a = on.split('.'), plugin = _a[0], event_1 = _a[1];
                var jwPlugin = _this.instance.getPlugin(plugin);
                if (jwPlugin) {
                    jwPlugin.on(event_1, func);
                    _this.info("subscribed to event ".concat(event_1, " for plugin ").concat(plugin));
                }
            }
            else {
                _this.instance.on(on, func);
                _this.info("subscribed to event ".concat(on));
            }
        };
        /**
         * Default JW player events to subscribe to
         */
        _this.onAll = function (event) {
            switch (event) {
                case 'buffer':
                case 'bufferChange':
                case 'time':
                case 'userInactive':
                case 'userActive':
                    break;
                default:
                    _this.log('warn', 'Send[JW]', event);
            }
            return false;
        };
        _this.onPlaylist = function () {
            _this.state.video.volume = _this.instance.getConfig().volume;
            _this.state.ad.breakCount = 0;
            return {
                event_label: 'loadplaylist',
                event_action: 'loadplaylist',
            };
        };
        _this.onAdBreakStart = function () {
            _this.state.ad.breakCount++;
            _this.state.ad.event = null;
            return false;
        };
        _this.onAdStart = function (_event) {
            return false;
        };
        _this.onAdTime = function (event) {
            var _a;
            if ((_this.state.ad.event && !_this.state.ad.paused) || ((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState()) !== 'playing') {
                return false;
            }
            if (_this.state.attemptPlay) {
                _this.state.attemptPlay = false;
                if (!_this.adobeDelay) {
                    _this.sendEvent(_this.formatAdEvent(event, {
                        event_label: 'ad_play',
                        event_action: 'ad_play',
                    }));
                }
            }
            var eventAction = 'ad_play';
            if (!_this.state.ad.event || event.id !== _this.state.ad.event.id) {
                _this.state.ad.event = event;
                eventAction = 'ad_start';
            }
            else if (_this.state.ad.paused) {
                eventAction = 'ad_resume';
            }
            _this.state.ad.paused = false;
            return _this.formatAdEvent(event, {
                event_label: eventAction,
                event_action: eventAction,
            });
        };
        _this.onAdPlay = function () {
            return false;
        };
        _this.onAdPause = function () {
            _this.state.ad.paused = true;
            _this.state.attemptPlay = true;
            return _this.formatAdEvent(_this.state.ad.event, {
                event_label: 'ad_pause',
                event_action: 'ad_pause',
            });
        };
        _this.onAdComplete = function () {
            var event = _this.state.ad.event;
            _this.state.ad.event = null;
            return _this.formatAdEvent(event, {
                event_label: 'ad_complete',
                event_action: 'ad_complete',
            });
        };
        _this.onAdClick = function () {
            return _this.formatAdEvent(_this.state.ad.event, {
                event_label: 'ad_click',
                event_action: 'ad_click',
            });
        };
        _this.onBufferChange = function (event) {
            var _a;
            var levels = (_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getQualityLevels();
            _this.info('onBufferChange', { event: event, levels: levels });
            return false;
        };
        _this.onVisualQuality = function (visualQuality) {
            if (!visualQuality.level)
                return false;
            _this.state.visualQuality = visualQuality;
            return {
                event_action: 'quality_adjust',
                event_label: "".concat(visualQuality.level.height, "p"),
            };
        };
        _this.onPlaylistItem = function () {
            _this.state.video.started = true;
            _this.state.video.position = 0;
            _this.state.visualQuality = null;
            return {
                event_label: 'load_media',
                event_action: 'load_media',
            };
        };
        _this.onBeforePlay = function (event) {
            if (event.playReason === 'interaction')
                _this.state.attemptPlay = true;
            if (_this.adobeDelay || _this.loadMediaSent || EventLog_1.default.didEventOccurred('player_load_media', constants_1.CallType.VIDEO))
                return false;
            // Used in case the load_media has not been send yet
            _this.loadMediaSent = true;
            return {
                event_label: 'load_media',
                event_action: 'load_media',
            };
        };
        _this.onPlay = function () {
            if (_this.isLastEvent('resume') || _this.state.video.scrubbing) {
                return false;
            }
            _this.state.completeSent = false;
            if (_this.adobeDelay && !EventLog_1.default.didEventOccurred('player_load_media', constants_1.CallType.VIDEO)) {
                _this.sendEvent({
                    event_label: 'load_media',
                    event_action: 'load_media',
                });
            }
            if (_this.state.attemptPlay) {
                _this.state.attemptPlay = false;
                _this.sendEvent({
                    event_label: 'play',
                    event_action: 'play',
                });
            }
            var eventAction = 'resume';
            if (_this.state.video.started) {
                _this.state.video.started = false;
                eventAction = 'start';
            }
            return {
                event_action: eventAction,
                event_label: eventAction,
            };
        };
        _this.onTime = function (event) {
            _this.state.video.position = event.position;
            var utag = window.utag;
            if (utag && utag.media) {
                utag.media.video_current_playhead = event.position;
            }
            if (_this.isLastEvent('play')) {
                if (_this.state.video.started) {
                    _this.state.video.started = false;
                    return {
                        event_label: 'start',
                        event_action: 'start',
                    };
                }
                return {
                    event_label: 'resume',
                    event_action: 'resume',
                };
            }
            return false;
        };
        _this.onPause = function () {
            if (_this.isLastEvent('pause')) {
                return false;
            }
            return {
                event_label: 'pause',
                event_action: 'pause',
            };
        };
        _this.onRemove = function () {
            var _a;
            var eventLabel = _this.state.video.position;
            _this.state.video.position = 0;
            _this.state.ad.event = null;
            if (((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState()) !== 'playing') {
                return false;
            }
            return {
                event_label: eventLabel,
                event_action: 'stop',
            };
        };
        _this.onIdle = function (event) {
            if (_this.isLastEvent('stop') || _this.state.video.position === 0) {
                return false;
            }
            if (event.reason === 'complete') {
                _this.state.completeSent = true;
                return {
                    event_action: 'complete',
                };
            }
            var eventLabel = _this.state.video.position;
            _this.state.video.position = 0;
            return {
                event_label: eventLabel,
                event_action: 'stop',
            };
        };
        _this.onComplete = function () {
            if (_this.isLastEvent('complete') || _this.state.completeSent) {
                return false;
            }
            _this.state.completeSent = true;
            return {
                event_action: 'complete',
            };
        };
        _this.onSeek = function (event) {
            if (event.position - event.offset === 10 ||
                (parseInt(event.position, 10) < 10 && parseInt(event.offset, 10) === 0)) {
                return {
                    event_label: 'rewind',
                    event_action: 'rewind',
                };
            }
            _this.state.video.scrubbing = _this.instance.getConfig().scrubbing;
            if (_this.isLastEvent('pause') || _this.isLastEvent('play')) {
                return {
                    event_action: 'seek',
                    event_label: event.position,
                    media_offset: event.position,
                };
            }
            return false;
        };
        _this.onSeeked = function () {
            var _a, _b;
            if (_this.state.video.scrubbing) {
                return false;
            }
            return {
                event_action: 'seeked',
                event_label: (_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getPosition(),
                media_offset: (_b = _this.instance) === null || _b === void 0 ? void 0 : _b.getPosition(),
            };
        };
        _this.onNextClick = function () {
            // Todo: add proper next event
            return _this.onComplete();
            // return {
            //   event_action: 'complete',
            // };
        };
        _this.onError = function (event) {
            return {
                event_label: event.message,
                event_value: event.code,
                event_action: 'error',
            };
        };
        _this.onFullscreen = function (event) {
            return {
                event_label: event.fullscreen,
                event_action: 'fullscreen',
            };
        };
        _this.onMute = function (event) {
            var _a;
            var lastEvent = EventLog_1.default.getLastEvent();
            if (event.mute === false && lastEvent.event_name === 'player_volume' && lastEvent.event_label === 'up') {
                return false;
            }
            var volume = event.mute ? 0 : ((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getVolume()) || 100;
            _this.state.video.volume = volume;
            return {
                event_value: volume,
                event_label: event.mute ? 'mute' : 'unmute',
                event_action: 'volume',
            };
        };
        _this.onVolume = function (event) {
            var volumeState = event.volume > _this.state.video.volume ? 'up' : 'down';
            _this.state.video.volume = event.volume;
            return {
                event_value: event.volume,
                event_label: volumeState,
                event_action: 'volume',
            };
        };
        _this.onPlaylistComplete = function () { return ({
            event_label: _this.instance ? _this.instance.getPosition() * 1000 : '',
            event_action: 'stop',
        }); };
        _this.onSharingClick = function (event) {
            return {
                event_value: event.method,
            };
        };
        _this.onCaptionsChanged = function (event) {
            var track = event.tracks[event.track];
            var subtitleLabel = track.id === 'off' ? 'off' : 'on';
            return {
                event_label: subtitleLabel,
                event_action: 'subtitles',
            };
        };
        _this.onDisplayClick = function () {
            var _a;
            if (((_a = _this.instance) === null || _a === void 0 ? void 0 : _a.getState()) === 'complete') {
                return {
                    event_label: 'replay',
                    event_action: 'replay',
                };
            }
            return false;
        };
        _this.name = 'JwMonitor';
        _this.events = {
            playlist: _this.onPlaylist,
            adBreakStart: _this.onAdBreakStart,
            adStarted: _this.onAdStart,
            adTime: _this.onAdTime,
            adPlay: _this.onAdPlay,
            adPause: _this.onAdPause,
            adComplete: _this.onAdComplete,
            adClick: _this.onAdClick,
            // Todo
            // bufferChange: this.onBufferChange,
            visualQuality: _this.onVisualQuality,
            playlistItem: _this.onPlaylistItem,
            beforePlay: _this.onBeforePlay,
            play: _this.onPlay,
            time: _this.onTime,
            pause: _this.onPause,
            idle: _this.onIdle,
            complete: _this.onComplete,
            seek: _this.onSeek,
            seeked: _this.onSeeked,
            nextClick: _this.onNextClick,
            error: _this.onError,
            fullscreen: _this.onFullscreen,
            mute: _this.onMute,
            volume: _this.onVolume,
            playlistComplete: _this.onPlaylistComplete,
            'sharing.click': _this.onSharingClick,
            captionsChanged: _this.onCaptionsChanged,
            displayClick: _this.onDisplayClick,
            remove: _this.onRemove,
        };
        return _this;
    }
    return JwMonitor;
}(Base_1.default)))();
